import { useEffect, useState } from "react";
import { TiPencil } from "react-icons/ti";
import ButtonElement from "../../Common/ButtonElement";
import TableComponent from "../components/TableComponent";
import SearchBox from "../components/SearchComponent";
import AddCompany from "./components/AddCompany";
import DateRangeSelector from "../../Common/DateRangeElement";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { appApis, headerColumn } from "../../constants";
import { downloadCsv, formatDate, isValidObject, parseByDateRange, parseNumber } from "../../utils";
import { getCompanies } from "../../actions/companies";
import AddPayment from "../Payment/components/AddPayment";
import { MdOutlineCurrencyRupee, MdOutlineFileDownload } from "react-icons/md";
import PaymentDetails from "../Payment/components/PaymentDetails";
import { useApiRequest } from "../../hooks/useApiRequest";
import { GiTakeMyMoney } from "react-icons/gi";

const CompanyPage = () => {
    const [state, setState] = useState({
        addCompany: false,
        addbilling: false,
        showDetails: false,
        editCompany: {},
        loading: false,
        search: "",
        companiesList: [],
        list: [],
        current: 1,
        totalPages: 1
    });
    const dispatch = useDispatch();
    const { request: downloadRequest, loading: isdownloading } = useApiRequest();
    const { companies, total } = useSelector(state => state.companies, shallowEqual);
    const { addCompany, editCompany, totalPages, current, companiesList, loading, search, list, showDetails, addbilling } = state;

    const filterByData = (range) => {
        if (isValidObject(range)) {
            const data = parseByDateRange(companies, range)
            setState(prev => ({ ...prev, list: data }))
        }
    }

    const downloadData = () => {
        downloadRequest({
            url: appApis.downloadCompaniesData,
            showToast: false,
            onSuccess: (responseData) => {
                downloadCsv(responseData ?? "", "companies");
            }
        })
    }

    const refreshCompanies = () => {
        dispatch(getCompanies());
    }

    useEffect(() => {
        refreshCompanies();
    },[])
    

    useEffect(() => {
        setState(prev => ({ ...prev, companiesList: companies, totalPages: total }));
    }, [companies])

    useEffect(() => {
        const items = search ? companiesList?.filter((item) => {
            const searchLower = search.toLowerCase();
            return (item.name?.toLowerCase().includes(searchLower) ||
                item.mobileNo?.toLowerCase().includes(searchLower)) ||
                item.gstNumber?.toLowerCase().includes(searchLower)
        }) : companiesList;
        setState(prev => ({ ...prev, list: items }))
    }, [search, companiesList]);

    return <div className="company-container">
        <SearchBox placeholder="Search here..." className="mb-3" value={search} onChange={(e) => setState(prev => ({ ...prev, search: e.target.value }))} />
        <TableComponent col={4} breakPoint="lg" title={"Company Management"} data={list} tableLoading={loading} current={current} total={totalPages} headers={headerColumn.companies} render={(tdData, index) => <tr key={`${tdData?.companyId}-${index}`}>
            <td>{(index ?? 0) + 1}</td>
            <td>{tdData?.companyName ?? "-"}</td>
            <td>{tdData?.contactPerson ?? "-"}</td>
            <td>{tdData?.mobileNo ?? "-"}</td>
            <td>{tdData?.gstNumber ?? "-"}</td>
            <td>{formatDate(tdData?.createdAt ?? "")}</td>
            <td>{tdData?.outstandingAmount ?? "-"}</td>
            <td>
                <ButtonElement text={<GiTakeMyMoney size={20} />} cssClass={`more-radius mx-1 opacity-75`} onClick={(e) => {
                    e.stopPropagation();
                    setState(prev => ({ ...prev, showDetails: true, editCompany: tdData ?? {} }))
                }} variant="btn-success" loading={false} />

                <ButtonElement text={<TiPencil size={20} />} cssClass="more-radius mx-1 px-4" onClick={(event) => {
                    event.stopPropagation();
                    setState(prev => ({ ...prev, addCompany: true, editCompany: tdData ?? {} }))
                }} variant="btn-outline-edit" loading={false} />

                <ButtonElement disabled={parseNumber(tdData?.outstandingAmount ?? "") ? false : true} text={<MdOutlineCurrencyRupee size={20} />} cssClass="more-radius mx-1 px-4" onClick={(event) => {
                    event.stopPropagation();
                    if (parseNumber(tdData?.outstandingAmount ?? "")) {
                        setState(prev => ({
                            ...prev, addbilling: true, editCompany: {
                                companyname: tdData?.companyName ?? "",
                                totalamount: tdData?.outstandingAmount ?? 0,
                                companyId: tdData?.companyId ?? 0,
                            }
                        }))
                    }
                }} variant="btn-outline-success" loading={false} />
            </td>
        </tr>} FilterComponent={<>
            <DateRangeSelector updateRange={filterByData} />
            <ButtonElement loading={isdownloading} text={<MdOutlineFileDownload fontSize={24} />} cssClass="small-radius me-1 mb-1" onClick={downloadData} variant="btn-outline-grey" />
            <ButtonElement text={"Add Company"} cssClass="small-radius me-1 mb-1" onClick={() => setState(prev => ({ ...prev, addCompany: true }))} variant="btn-black" loading={false} />
        </>} />
        {addCompany ? <AddCompany show={addCompany} companyData={editCompany} hideModal={() => setState(prev => ({ ...prev, addCompany: false, editCompany: {} }))} /> : null}
        {addbilling ? <AddPayment show={addbilling} hideModal={() => setState(prev => ({ ...prev, addbilling: false, editCompany: {} }))} extraDetails={editCompany} getInstData={refreshCompanies} /> : null}
        {showDetails ? <PaymentDetails show={showDetails} hideModal={() => setState(prev => ({ ...prev, showDetails: false, editCompany: {} }))} query={`companyId=${editCompany?.companyId}`} /> : null}
    </div>
}

export default CompanyPage;